module.exports = __webpack_public_path__ + "static/media/brand.6e5acb90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/brand.svg
// module id = 21
// module chunks = 0